<template>
    <breadCrumbs title="User Profile" main="Users" title1="User Profile" />


    <div class="container-fluid">
        <div class="user-profile">
            <div class="row">

                <headerPage />

                <div class="col-xl-3 col-md-5 xl-35 box-col-35">
                    <div class="default-according style-1 job-accordion">
                        <div class="row">
                            <aboutMe />
                            <followersPage />
                        </div>
                    </div>
                </div>
                <div class="col-xl-9 col-md-7 xl-65 box-col-65">
                    <div class="row">

                        <post1Page />

                        <post2Page />

                        <post3Page />

                    </div>
                </div>


            </div>
        </div>
    </div>
</template>

<script>
import headerPage from '../profile/headerPage.vue'
import aboutMe from '../profile/aboutMe.vue'
import followersPage from '../profile/followersPage.vue'
import post1Page from '../profile/post1Page.vue'
import post2Page from '../profile/post2Page.vue'
import post3Page from '../profile/post3Page.vue'
export default {
    name: 'userProfile',
    components: {
        headerPage,
        aboutMe,
        followersPage,
        post1Page, post2Page, post3Page
    },

}
</script>
